import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-block-turns',
  templateUrl: './block-turns.component.html',
  styleUrls: ['./block-turns.component.scss'],
})
export class BlockTurnsComponent implements OnInit {
  @Input() currentDate: Date = undefined;
  public initHour = '';
  public endHour = '';
  public operatorId = '';
  public operators: any[] = [];

  constructor(
    public authSv: LoginService,
    private modalController: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices
  ) {}

  async ngOnInit() {
    const res = await this.httpSv.itemIndex('admin/user/index//8/', '', '', '');
    this.operators = res.data;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async save() {
    try {
      if (
        this.initHour === '' ||
        this.endHour === '' ||
        (this.authSv.user.rolId === 3 && this.operatorId === '')
      ) {
        this.uiSv.showToast('Todos los campos son requeridos');
        return;
      }

      const splitedDate = this.currentDate.toISOString().split('T')[0];
      const res = await this.httpSv.itemAction(
        {
          name: `Bloqueo ${this.currentDate}`,
          init: `${splitedDate}T${this.initHour}:00`,
          end: `${splitedDate}T${this.endHour}:00`,
          operatorId:
            this.authSv.user.rolId !== 3
              ? this.authSv.user.id
              : this.operatorId,
        },
        'blockTurns',
        'store'
      );

      if (res.status) {
        this.uiSv.showToast('Bloqueo guardado');
        await this.modalController.dismiss();
      }
    } catch (error) {
      console.error(error);
    }
  }
}
